<template>
    <div class="site-manager">
        <legend>Unit Credentials</legend>
        <p v-if="!this.unitId">
            Please associate with a unit before issuing network credentials.
        </p>
        <p v-else-if="!this.loading && this.unitCredentials.length === 0">No Network Credentials Found</p>
        <div v-else>
            <div v-for="(cred, index) in this.unitCredentials" :key="cred.id">
                <label v-if="isLeaseCredential(index)" class="label label-warning">My Lease Credential</label><br>
                <site-manager-credential
                    :unit-id="unitId"
                    :app-url="appUrl"
                    :credential="cred"
                    :future-credential-activation-date="getActivationDate(index + 1)"
                ></site-manager-credential>
            </div>
        </div>
        <p v-if="!this.resident">
            <i>Note:</i> Associate this user with a resident to create a credential. <br><a href="javascript://void(0)" @click="confirmCreateUnverifiedResident">Can't find the resident?</a>
        </p>
        <button
            class="btn btn-md btn-primary"
            :disabled="loading || !this.resident || hasLeaseCredential"
            @click="confirmCreateCredential"
        >
            Create Credential
        </button>
        <modal :name=modalId
               :adaptive="true"
               :scrollable="true"
               height="auto">
            <div class="dashboard-block" :class="{loading: loading}">
                <div v-if="modalType === MODAL_CREATE_CREDENTIAL">
                    <header>
                        <h4 v-if="this.resident">New Credential Details</h4>
                        <h4 v-else>Unable to create network credential</h4>
                        <a href="javascript://void(0)" class="back" @click="closeModal">Close</a>
                    </header>
                    <div v-if="this.resident">
                        <div class="row">
                            <div class="col-sm-12 form-group has-feedback"
                                    :class="{'has-error': this.error.email !== null}">
                                <label for="email">Email</label>
                                <input id="email"
                                        name="email"
                                        type="text"
                                        v-model="email"
                                        class="form-control">

                                <span v-show="this.error.email !== null" class="help-block">
                                    {{ this.error.email }}
                                </span>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-sm-6 form-group has-feedback"
                                :class="{'has-error': this.error.activationDate !== null}">
                                <label for="activation_date">Activation Date</label>
                                <input id="activation_date"
                                        required="required"
                                        name="activation_date"
                                        type="date"
                                        v-validate="'required'"
                                        v-model="activationDate"
                                        class="form-control">

                                <span v-show="this.error.activationDate !== null" class="help-block">
                                    {{ this.error.activationDate }}
                                </span>
                            </div>

                            <div class="col-sm-6 form-group has-feedback"
                                :class="{'has-error': this.error.activationDate !== null}">
                                <label for="deactivation_date">Deactivation Date</label>
                                <input id="activation_date"
                                        name="deactivation_date"
                                        type="date"
                                        v-model="deactivationDate"
                                        class="form-control">

                                <span v-show="this.error.deactivationDate !== null" class="help-block">
                                    {{ this.error.deactivationDate }}
                                </span>
                            </div>
                        </div>

                        <br>

                        <button class="btn btn-md btn-primary" @click="createNetworkCredential">
                            Create New Credential
                        </button>
                    </div>
                    <div v-else>
                        Please associate with a resident to assign a new network credential
                    </div>
                </div>
                <div v-else-if="this.modalType === this.MODAL_CREATE_RESIDENT">
                    <header>
                        <h4>Are you sure?</h4>
                        <a href="javascript://void(0)" class="back" @click="closeModal">Close</a>
                    </header>
                    <div>
                        <p><span style="color: red;"><i><b>Warning:</b></i></span> Ensure no relevant resident record exists to prevent duplicate residents</p>
                        <br>

                        <button class="btn btn-md btn-primary" @click="createUnverifiedResident">
                            Create Resident
                        </button>
                    </div>
                </div>
            </div>
        </modal>
    </div>
</template>

<script>
    const MODAL_CREATE_CREDENTIAL = 1;
    const MODAL_CREATE_RESIDENT = 2;

    export default {
        props: {
            modalId: {
                default(){
                    return _.uniqueId( 'modal_' );
                },
                type: String
            },
            unitId: {
                required: false,
                type: [String, null]
            },
            // residentId: {
            //     required: false,
            //     type: [String, null]
            // },
            // userId: {
            //     required: false,
            //     type: [String, null]
            // },
            resident: {
                required: false,
                type: [Object, null]
            },
            user: {
                required: false,
                type: [Object, null]
            },
            appUrl: {
                required: true,
                type: String
            }
        },

        data(){
            return {
                MODAL_CREATE_CREDENTIAL,
                MODAL_CREATE_RESIDENT,
                loading: true,
                unitCredentials: [],
                email: '',
                activationDate: null,
                deactivationDate: null,
                confirmation: false,
                modalType: MODAL_CREATE_CREDENTIAL,
                // resident: null,
                // user: null,
                error: {
                    activationDate: null,
                    deactivationDate: null,
                    email: null
                }
            };
        },

        // If the resident is future, we pull the future credential,
        // If a credential exists, and we don't know if our resident is current or future,
        // We can show the credential & the email it is tied to
        // if we don't know, we pull the current active credential for the unit
        // PULL a list of ALL current or pending unit credentials
        mounted() {
            this.init();
            this.loadUnitCredentials()
                // .then(this.loadResident)
                // .then(this.loadUser)
                .then(res => {
                    this.email = this.defaultEmail;
                })
                .catch( this.$root.handleErrors )
                .finally(() => this.loading = false)
        },

        computed: {
            defaultEmail() {
                if (this.resident) return this.resident.email;
                if (this.user) return this.user.email;
                return '';
            },

            hasLeaseCredential() {
                for (let i = 0; i < this.unitCredentials.length; i++) {
                    if (this.isLeaseCredential(i)) {
                        return true;
                    }
                }
                return false;
            }
        },

        methods: {
            init() {
                if (this.resident) {
                    let now = new Date();
                    let offset = now.getTimezoneOffset();
                    now = new Date(now.getTime() - (offset * 60 * 1000));
                    let nowFormatted = now.toISOString().split('T')[0];
                    let leaseStart = new Date(this.resident.lease.start_at ? this.resident.lease.start_at : nowFormatted);
                    this.activationDate = leaseStart && leaseStart > now ? leaseStart.toISOString().split('T')[0] : nowFormatted;
                }
            },

            loadUnitCredentials() {
                if (this.unitId) {
                    var url = this.appUrl + '/api/tami/networkCredential?unitId=' + this.unitId;
                    return axios.get( url )
                        .then(res => {
                            this.unitCredentials = res.data.data.sort((a, b) => (new Date(a.activationDate) < new Date(b.activationDate)) ? -1 : 1);
                        } )
                        .catch(err => {
                            if (err.response.data.error) {
                                this.$notify( {
                                    type: 'success',
                                    placement: 'top-left',
                                    title: err.response.data.data,
                                } );
                            }
                        })
                }
                else {
                    return Promise.resolve();
                }
            },

            // loadResident() {
            //     if (this.resident?.id) {
            //         var url = this.appUrl + '/api/residents/' + this.residentId;
            //         return axios.get( url )
            //             .then(res => {
            //                 this.resident = res.data.Resident;
            //                 let now = new Date();
            //                 let offset = now.getTimezoneOffset();
            //                 now = new Date(now.getTime() - (offset * 60 * 1000));
            //                 let nowFormatted = now.toISOString().split('T')[0];
            //                 let leaseStart = new Date(res.data.Resident.lease.start_at ? res.data.Resident.lease.start_at : nowFormatted);
            //                 this.activationDate = leaseStart && leaseStart > now ? leaseStart.toISOString().split('T')[0] : nowFormatted;
            //             });
            //     }
            //     else {
            //         return Promise.resolve();
            //     }
            // },

            // loadUser() {
            //     if (this.userId) {
            //         var url = this.appUrl + '/api/users/' + this.userId;
            //         return axios.get( url )
            //             .then(res => {
            //                 this.user = res.data.User;
            //             });
            //     }
            //     else {
            //         return Promise.resolve();
            //     }
            // },

            confirmCreateCredential() {
                this.modalType = this.MODAL_CREATE_CREDENTIAL;
                this.openModal();
            },

            confirmCreateUnverifiedResident() {
                this.modalType = this.MODAL_CREATE_RESIDENT;
                this.openModal();
            },

            closeModal() {
                this.$modal.hide( this.modalId );
                this.modalType = this.MODAL_CREATE_CREDENTIAL;
            },

            openModal() {
                this.$modal.show( this.modalId );
            },

            createNetworkCredential() {
                this.loading = true;

                if (!this.validateNewCredential()) {
                    this.loading = false;
                    return;
                }
                else {
                    this.resetErrors();
                }

                var url = this.appUrl + '/api/tami/networkCredential';
                return axios.post(url, {
                    'unitId': this.unitId,
                    'residentId': this.resident ? this.resident.id : null,
                    'email': this.email,
                    'activationDate': this.activationDate,
                    'deactivationDate': this.deactivationDate
                })
                    .then(response => {
                        this.$notify( {
                            type: 'success',
                            placement: 'top-left',
                            title: 'Network Credential Created',
                        } );
                        window.location.reload();
                    })
                    .catch(err => {
                        if (err.response.data.error && err.response.data.data) {
                            this.$notify( {
                                type: 'danger',
                                placement: 'top-left',
                                title: err.response.data.data
                            } );
                        }
                        else {
                            this.$notify( {
                                type: 'danger',
                                placement: 'top-left',
                                title: 'Something went wrong creating a network credential. Refresh the page and try again.'
                            } );
                        }
                    })
                    .finally((res) => {
                        this.loading = false;
                        this.closeModal();
                    });
            },

            createUnverifiedResident() {
                this.loading = true;
                var url = this.appUrl + '/api/tami/resident/' + this.user.id;
                return axios.post(url, null)
                    .then(response => {
                        this.$notify( {
                            type: 'success',
                            placement: 'top-left',
                            title: 'Resident Created',
                        } );
                        window.location.reload();
                    })
                    .catch(err => {
                        if (err.response.data.error && err.response.data.data) {
                            this.$notify( {
                                type: 'danger',
                                placement: 'top-left',
                                title: err.response.data.data
                            } );
                        }
                        else {
                            this.$notify( {
                                type: 'danger',
                                placement: 'top-left',
                                title: 'Something went wrong creating a resident. Refresh the page and try again.'
                            } );
                        }
                    })
                    .finally((res) => {
                        this.loading = false;
                        this.closeModal();
                    });
            },

            // Helper functions / Computed values / etc
            formatTime(date) {
                let hours = date.getHours();
                let minutes = date.getMinutes();
                let ampm = hours >= 12 ? 'pm' : 'am';
                hours = hours % 12;
                hours = hours ? hours : 12;
                minutes = minutes.toString().padStart(2, '0');
                let strTime = hours + ':' + minutes + ampm;
                return strTime;
            },

            // Validation / UI Feedback
            validateNewCredential() {
                this.resetErrors();
                let succeed = true;

                // Check valid email
                if (!this.email) {
                    this.error.email = 'Invalid email';
                    succeed = false;
                }

                // Check valid activation date
                let earliestActivationDate = new Date();
                let activation = new Date(this.activationDate + "T14:00:00.000Z");
                activation.setHours(6);
                earliestActivationDate.setHours(4);
                if (activation < earliestActivationDate) {
                    this.error.activationDate = 'Cannot set activation date in the past.';
                    succeed = false;
                }

                // Check deactivation is after activation
                let deactivation = new Date(this.deactivationDate + "T15:00:00.000Z");
                deactivation.setHours(9);
                if (deactivation < activation) {
                    this.error.deactivationDate = 'Cannot set a deactivation date before the activation date.';
                    succeed = false;
                }

                return succeed;
            },

            getActivationDate(index) {
                return this.unitCredentials.length - 1 >= index
                ? new Date(this.unitCredentials[index].activationDate)
                : null;
            },

            resetErrors() {
                this.error = {
                    activationDate: null,
                    deactivationDate: null,
                    email: null
                };
            },

            isLeaseCredential(i) {
                if (this.unitCredentials.length - 1 >= i && this.resident) {
                    return this.resident.lease_id === this.unitCredentials[i].legacyAdminResident.lease_id;
                }
                return false;
            }
        }
    }
</script>
